export enum TableColumns {
    ROW_NUMBER = 'rowNumber',
    LANGUAGE = 'language',
    CARRIER  = 'carrierName',
    DEALER   = 'dealerName',
    LABEL    = 'label',
    VALUE    = 'value',
    ACTIONS  = 'actions'
}
